/**
 * @generated SignedSource<<e3b2819b50eebedf49c76ec673deab23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type WidgetSpace_widgetSpace$data = {
  readonly id: string;
  readonly subWidgets: ReadonlyArray<{
    readonly __typename: "WidgetFile";
    readonly height: number;
    readonly id: string;
    readonly overviewSize: WidgetOverviewSize;
    readonly positionX: number;
    readonly positionY: number;
    readonly width: number;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetFile_widgetFile">;
  } | {
    readonly __typename: "WidgetNote";
    readonly height: number;
    readonly id: string;
    readonly noteSize: WidgetNoteSize;
    readonly positionX: number;
    readonly positionY: number;
    readonly width: number;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetNote_widgetNote">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetSpace_widgetSpace";
};
export type WidgetSpace_widgetSpace$key = {
  readonly " $data"?: WidgetSpace_widgetSpace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetSpace_widgetSpace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionX",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionY",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetSpace_widgetSpace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "subWidgets",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "overviewSize",
              "storageKey": null
            },
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetFile_widgetFile"
            },
            (v5/*: any*/)
          ],
          "type": "WidgetFile",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "noteSize",
              "storageKey": null
            },
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetNote_widgetNote"
            },
            (v5/*: any*/)
          ],
          "type": "WidgetNote",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetSpace",
  "abstractKey": null
};
})();

(node as any).hash = "6651794b6b17bfb15ef68654e0245cf2";

export default node;
